import { useContext, useEffect, useMemo, useState } from 'react';
import { AppContext } from '../contexts/AppContext';
import { get } from 'lodash';

export const enum NAME_PATH {
  PREFERENCE = 'preference',
  FONT_SIZE = 'preference.fontSize',
}

type TralitSettingOpt = {
  preference: {
    fontSize: {
      menu: number;
      title: number;
      chartTitle: number;
      tableTitle: number;
      tag: number;
      chart: number;
      table: number;
    };
    llm: string;
    menuLine: number;
    anchorLine: number;
  };
  account: string;
};

type TralitSettingProp = {
  namePath: string;
};

export const defaultSize = '大';

export const defaultFontSize = {
  menu: {
    大: 18,
    中: 16,
    小: 14,
  },
  title: {
    大: 22,
    中: 18,
    小: 16,
  },
  chartTitle: {
    大: 22,
    中: 20,
    小: 18,
  },
  tableTitle: {
    大: 22,
    中: 20,
    小: 18,
  },
  tag: {
    大: 17,
    中: 14,
    小: 12,
  },
  chart: {
    大: 17,
    中: 14,
    小: 12,
  },
  table: {
    大: 17,
    中: 15,
    小: 14,
  },
};

export const useTralitSetting = (prop?: TralitSettingProp) => {
  const { namePath } = prop || {};

  const { tralitSettings } = useContext(AppContext);

  // font size
  const fontSizeSettings = useMemo(
    () => ({
      preference: {
        fontSize: defaultFontSize,
      },
    }),
    []
  );

  const [setting, setSetting] = useState<TralitSettingOpt>({
    preference: {
      fontSize: {
        menu: fontSizeSettings.preference.fontSize.menu[defaultSize],
        title: fontSizeSettings.preference.fontSize.title[defaultSize],
        chartTitle: fontSizeSettings.preference.fontSize.chartTitle[defaultSize],
        tableTitle: fontSizeSettings.preference.fontSize.tableTitle[defaultSize],
        tag: fontSizeSettings.preference.fontSize.tag[defaultSize],
        chart: fontSizeSettings.preference.fontSize.chart[defaultSize],
        table: fontSizeSettings.preference.fontSize.table[defaultSize],
      },
      llm: 'chatgpt-4.1',
      menuLine: 1,
      anchorLine: 1,
    },
    account: null,
  });

  useEffect(() => {
    if (tralitSettings.fontSize === 'custom') {
      setSetting({
        preference: {
          fontSize: {
            menu: tralitSettings.menu,
            title: tralitSettings.title,
            chartTitle: tralitSettings.chartTitle,
            tableTitle: tralitSettings.tableTitle,
            tag: tralitSettings.tag,
            chart: tralitSettings.chart,
            table: tralitSettings.table,
          },
          llm: tralitSettings.llm,
          menuLine: tralitSettings.menuLine,
          anchorLine: tralitSettings.anchorLine,
        },
        account: tralitSettings.account,
      });
    } else {
      setSetting({
        preference: {
          fontSize: {
            menu: fontSizeSettings.preference.fontSize.menu[tralitSettings.fontSize || defaultSize],
            title: fontSizeSettings.preference.fontSize.title[tralitSettings.fontSize || defaultSize],
            chartTitle: fontSizeSettings.preference.fontSize.chartTitle[tralitSettings.fontSize || defaultSize],
            tableTitle: fontSizeSettings.preference.fontSize.tableTitle[tralitSettings.fontSize || defaultSize],
            tag: fontSizeSettings.preference.fontSize.tag[tralitSettings.fontSize || defaultSize],
            chart: fontSizeSettings.preference.fontSize.chart[tralitSettings.fontSize || defaultSize],
            table: fontSizeSettings.preference.fontSize.table[tralitSettings.fontSize || defaultSize],
          },
          llm: tralitSettings.llm,
          menuLine: tralitSettings.menuLine,
          anchorLine: tralitSettings.anchorLine,
        },
        account: tralitSettings.account,
      });
    }
  }, [tralitSettings]);

  return namePath ? get(setting, namePath) : setting;
};
